(function () {
  'use strict';

  /* @ngdoc object
   * @name itecAdministracio.shared.filters
   * @description
   *
   */
  angular
    .module('itecAdministracio.shared.filters', [
    ]);
}());
